"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBReadyToLearn", {
  enumerable: true,
  get: function get() {
    return _SVBReadyToLearn.default;
  }
});
var _SVBReadyToLearn = _interopRequireDefault(require("./src/SVBReadyToLearn"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }